export default __webpack_public_path__ + "static/mac-notebook-2-58bd1cae6e75ffd5c6ebce38d421c60b.jpg";